<template>
	<div class="add-form">
		<Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
			<div class="tag-title">公众号配置</div>
			<FormItem label="小程序appid" prop="wechat_appid">
				<Input style="width: 300px" v-model="form.wechat_appid" placeholder="请输入appid"></Input>
			</FormItem>
			<FormItem label="小程序secret" prop="wechat_secret">
				<Input style="width: 300px" v-model="form.wechat_secret" placeholder="请输入secret"></Input>
			</FormItem>
			<div class="tag-title">微信支付配置</div>
			<FormItem label="微信mchid" prop="mchid" key="mchid">
				<Input style="width: 300px" v-model="form.mchid" placeholder="请输入微信mchid"></Input>
			</FormItem>
			<FormItem label="微信key" prop="key" key="key">
				<Input style="width: 300px" v-model="form.key" placeholder="请输入微信key"></Input>
			</FormItem>
			<FormItem label="证书">
				<template v-if="form.certif == 0">
					<Upload
						:action="import_cert"
						:headers="headers"
						:on-error="uploadErr"
						:data="{ private: true, online: false }"
						:on-success="value => UploadSuccess('certif', value)"
						name="file"
						:show-upload-list="false"
					>
						<Button icon="ios-cloud-upload-outline">上传证书</Button>
					</Upload>
				</template>
				<template v-else>
					<div class="upload-info">已上传</div>
					<div>
						<Button type="primary" style="float: left; margin-right: 10px" @click="deleteCeat('certif')">
							删除证书
						</Button>
						<Upload
							:action="import_cert"
							:headers="headers"
							:on-error="uploadErr"
							:data="{ private: true, online: false }"
							:on-success="value => UploadSuccess('certif', value)"
							name="file"
							:show-upload-list="false"
						>
							<Button icon="ios-cloud-upload-outline" type="primary">重新上传</Button>
						</Upload>
					</div>
				</template>
				<span style="white-space: nowrap">
					证书下载路径：微信商户平台（
					<a href="https://pay.weixin.qq.com" rel="noopener" target="_blank">pay.weixin.qq.com</a>
					）-->账户中心-->账户设置-->API安全 。
				</span>
			</FormItem>
			<FormItem label="证书密钥">
				<template v-if="form.certif_key == 0">
					<Upload
						:action="import_cert"
						:headers="headers"
						:data="{ private: true, online: false }"
						:on-error="uploadErr"
						:on-success="value => UploadSuccess('certif_key', value)"
						name="file"
						:show-upload-list="false"
					>
						<Button icon="ios-cloud-upload-outline">上传密钥</Button>
					</Upload>
				</template>
				<template v-else>
					<div class="upload-info">已上传</div>
					<div>
						<Button type="primary" style="float: left; margin-right: 10px" @click="deleteCeat('certif_key')">
							删除密钥
						</Button>
						<Upload
							:action="import_cert"
							:headers="headers"
							:data="{ private: true, online: false }"
							:on-error="uploadErr"
							:on-success="value => UploadSuccess('certif_key', value)"
							name="file"
							:show-upload-list="false"
						>
							<Button icon="ios-cloud-upload-outline" type="primary">重新上传</Button>
						</Upload>
					</div>
				</template>
        
				<span style="white-space: nowrap">
					证书下载路径：微信商户平台（
					<a href="https://pay.weixin.qq.com" rel="noopener" target="_blank">pay.weixin.qq.com</a>
					）-->账户中心-->账户设置-->API安全 。
				</span>
			</FormItem>
			<FormItem label="模板Id" prop="template_id" key="template_id">
				<Input style="width: 300px" v-model="form.template_id" placeholder="请输入微信模板id"></Input>
			</FormItem>
		</Form>
		<Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
	</div>
</template>

<script>
	import { apiGetSystem, apiSetSystem } from '@/api/system'
	import utils from '@/utils'

	export default {
		name: 'add-form',
		data() {
			return {
				query: {},
				search: {},
				diyDom: {},
				// 表单数据
				form: {
					wechat_appid: '',
					wechat_secret: '',
					mchid: '',
					key: '',
					certif: '0', // 证书地址
					certif_key: '0', // 证书密钥
					template_id: '',
				},
				diyData: {
					rules: {
						wechat_appid: [{ required: true, message: '请输入appid', trigger: 'blur' }],
						wechat_secret: [{ required: true, message: '请输入secret', trigger: 'blur' }],
						mchid: [{ required: true, message: '请输入mchid', trigger: 'blur' }],
						key: [{ required: true, message: '请输入key', trigger: 'blur' }],
					},
				},
				apiData: {
					certif: '',
					certif_key: '',
				},
			}
		},
		computed: {
			import_cert() {
				return utils.getPrefix() + 'upload/file'
			},
			headers() {
				return {
					authorization: localStorage.getItem('token'),
				}
			},
		},
		methods: {
			// 获取配置
			getSettings() {
				this.$store.commit('setSpinShow', true)
				apiGetSystem('wechat')
					.then(res => {
						const { wechat_appid, wechat_secret, mchid, key, certif, certif_key, template_id } = res
						this.form.wechat_appid = wechat_appid
						this.form.wechat_secret = wechat_secret
						this.form.mchid = mchid
						this.form.key = key
						this.form.template_id = template_id
						this.form.certif = certif ? certif : '0'
						this.form.certif_key = certif_key ? certif_key : '0'
						// 将当前的证书和秘钥复制一份
						this.apiData.certif = this.form.certif
						this.apiData.certif_key = this.form.certif_key
					})
					.finally(() => this.$store.commit('setSpinShow', false))
			},
			UploadSuccess(type, res) {
				this.$Message.success('文件上传成功')
				if (type == 'certif') {
					this.form.certif = res.path
				} else if (type == 'certif_key') {
					this.form.certif_key = res.path
				}
			},
			uploadErr() {
				this.$Modal.error({
					title: '提示',
					content: '文件上传失败，请重试',
				})
			},
			deleteCeat(type) {
				for (let key in this.form) {
					if (type == key) {
						this.form[key] = '0'
					}
				}
			},
			submit() {
				this.$refs['addForm'].validate(valid => {
					if (valid) {
						this.form.certif = this.form.certif == '0' ? '' : this.form.certif
						this.form.certif_key = this.form.certif_key == '0' ? '' : this.form.certif_key
						apiSetSystem('wechat', {
							wechat: this.form,
						}).then(() => {
							this.$Message.success('保存成功')
							this.getSettings()
						})
					}
				})
			},
		},

		mounted() {
			this.getSettings()
		},
	}
</script>

<style scoped lang="less">
	.add-form {
		border: 1px solid #ededed;
		margin: 0 20px;
		padding: 26px 20px;

		.title {
			font-size: 14px;
			font-weight: bold;
			color: #333333;
			line-height: 19px;
			margin-bottom: 10px;
		}
	}
</style>
